/* eslint-disable no-await-in-loop */
/* eslint-disable radix */
import { GrupoFrotistaFormulario } from '@sotran/lib-shipper';
import { notification } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import SubHeader from '../../../components/SubHeader';
import { useAuth } from '../../../security/authContext';
import apiAuth from '../../../services/apiAuth';
import apiNetCore from '../../../services/apiNetCore';
import apiShipper from '../../../services/apiShipper';
import { SpinAllSize } from './styles';

const FormularioGrupoFrotista = () => {
  const { grupoFrotistaId } = useParams();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [clienteTmov, setClientTmov] = useState();
  const [grupoFrotista, setGrupoFrotista] = useState();
  const breadcrumbs = [
    {
      path: '/grupo-frotista',
      breadcrumbName: 'Parametrização',
    },
    {
      breadcrumbName:
        grupoFrotistaId != null
          ? 'Edição Grupo de Frotista'
          : 'Cadastro Grupo de Frotista',
    },
  ];

  const getGrupoFrotista = async () => {
    try {
      setLoading(true);
      const response = await apiNetCore.get(
        `/GrupoFrotista/GetById/${grupoFrotistaId}`
      );

      const grupoF = response.data;

      const arrayProprietarios = [];

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < grupoF.frotistas.length; i++) {
        const frotista = grupoF.frotistas[i];

        const { data } = await apiAuth.get(`/users/${frotista.idUsuario}`);

        arrayProprietarios.push({
          nomeFrotista: frotista.nome,
          idProprietario: frotista.idProprietario,
          idEmpresa: frotista.idEmpresa,
          cnpjCpf: frotista.cnpjcpf,
          cidade: ` ${frotista.cidade} - ${frotista.siglaEstado}`,
          nomeUsuario: data.name,
          createdAt: moment(frotista.DataCriacao).format('DD/MM/YYYY HH:mm:ss'),
        });
      }

      grupoF.frotistas = arrayProprietarios;

      setGrupoFrotista(grupoF);
      setLoading(false);
    } catch (error) {
      notification.error({
        message: 'Erro interno',
        description: 'Houve um erro buscar grupo',
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    const getCliente = async () => {
      setLoading(true);
      const { data } = await apiShipper.get(`/clientes/${user.cliente_id}`);
      const cliTmov = await apiShipper.get(
        `/clientes/tmov/raiz/full-search?descricao=${data.cnpj_resumido}`
      );

      setClientTmov(cliTmov.data[0]);
      setLoading(false);

      // eslint-disable-next-line no-extra-boolean-cast
      if (!!parseInt(grupoFrotistaId)) {
        getGrupoFrotista();
      }
    };

    getCliente();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ background: 'white' }}>
      <SpinAllSize size="large" spinning={loading}>
        <SubHeader breadcrumbs={breadcrumbs} />
        <div className="pl-30 pr-30">
          <GrupoFrotistaFormulario
            history={history}
            apiNetCore={apiNetCore}
            setLoading={setLoading}
            idCliente={clienteTmov?.id}
            // eslint-disable-next-line no-extra-boolean-cast
            grupoFrotistaId={
              parseInt(grupoFrotistaId) ? parseInt(grupoFrotistaId) : null
            }
            grupoFrotista={grupoFrotista}
            nomeProprietario={clienteTmov?.razao_social}
            usuario={{
              id: user.id,
              nome: user.name,
            }}
          />
        </div>
      </SpinAllSize>
    </div>
  );
};

export default FormularioGrupoFrotista;
